<template>
  <div>
    <MainForm
      :name="FORM_NAMES.needsReviewStp"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      :ui-form="uiForm"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.appointment"
        :ui-title="`${dynamicText}`"
        :ui-subtitle="`${dynamicTextName} You qualify for a ${product}!
          We just need some more information from you to confirm your offer.`"
        ui-error-message="Please review the fields marked in red"
        :ui-secondary-action="goToNextStepWithoutValidate"
      >
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.primaryAddress" :ui-title="title">
          <UiWrapper :name="FIELD_NAMES.primaryAddress">
            <Choice
              :options="[
                {
                  value: 'BUSINESS',
                  label: 'Office',
                },]"
              data-forced-fullwidth="true"
            />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel :ui="uiBaseFieldset" :name="name" ui-columns="2">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.nearestLandmark"
            label="Nearest landmark"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.residentialEmirate" label="Emirate" optional>
            <Dropdown placeholder="Emirate" :options="EMIRATE_LIST_CARD" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryCountry" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.poBox"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.localReference"
          ui-title="Please provide us with one local reference contact details (It could be your friend/colleague)"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameRefernce"
            label="Name"
            :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.referencePhoneNumber"
            label="Mobile Number"
            :validations="validations"
          >
            <InputText type="tel" :prefix="prefix" :maxlength="maxlength" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country reference contact details (family member/relative only)"
          :name="FIELDSET_NAMES.homeCountryReference"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.fullNameHomecountry"
            label="Name"
            :validations="[
          {
            'errorMessage': 'Field contains invalid characters',
            'condition': patternCondition(NAMES_CHARS),
            'name': 'lastname-chars',
          },
        ]"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryPhoneCountryCode" label="Country code">
            <Dropdown placeholder="Country code" :options="MAPPED_PHONE_CODE" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPhone"
            label="Mobile Number"
            :validations="validationsGlobal"
          >
            <InputText type="tel" :maxlength="minlengthGlobal" :minlength="minlength" />
          </UiWrapper>
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          ui-title="Please provide your home country address"
          name="homeCountryAddress"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAddress"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryAdditionalAddress"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>

          <UiWrapper :name="FIELD_NAMES.homeCountryCountry" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountries"
            />
          </UiWrapper>

          <UiWrapper
            :name="FIELD_NAMES.homeCountryPoscode"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
const GlobalVariables = {
  isThankYouScreen: false
};
import Vue from "vue";
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
// Utils
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import store from "@/store";
import FIELD_NAMES from "@/forms/constants/field-names";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
import FieldsetModel from "@/lib/components/models/fieldset";
import UiWrapper from "@/forms/components/base/ui-wrapper";
import Appointment from "@/forms/components/shared/fieldsets/appointment-date";
import uploadService from "@/forms/api/services/upload";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import {
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
  DIGIT_CHARS,
  NAMES_CHARS,
  MAPPED_PHONE_CODE,
  ADDRESS_CHARS
} from "@/forms/constants/onboarding-logic";
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest
} from "@dunia/ui";
const UPLOAD_FILE_NAMES = [
  FIELD_NAMES.firstSalaryFile,
  FIELD_NAMES.secondSalaryFile,
  FIELD_NAMES.thirdSalaryFile
];

export default {
  name: "NeedsReview",

  mixins: [FormComponentMixin],

  components: {
    // Components
    MainForm,
    StepModel,
    Appointment,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName
  },
  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetAddress
    },
    title: {
      type: String,
      default: "Please enter your office address below"
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number"
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length"
        }
      ]
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits"
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length"
        }
      ]
    },
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars"
        }
      ]
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars"
        }
      ]
    },
    prefix: {
      type: String,
      default: "+971"
    },
    maxlength: {
      type: Number,
      default: 9
    },
    minlength: {
      type: Number,
      default: 9
    },
    minlengthGlobal: {
      type: Number,
      default: 11
    }
  },
  data: () => ({
    UPLOAD_FILE_NAMES,
    uploadedFiles: [false, false, false]
  }),
  mounted() {
    console.log(GlobalVariables);
    var dsaSource = this.$store.state.source;
    // if (dsaSource === "Dsa" || dsaSource === "DSA" || dsaSource === "dsa") {
    //   this.finishCallback();
    // }
    // if (this.$store.state.employeeCodes && !appianIncomeInfoResponse) {
    //   this.finishCallback();
    // }
  },
  computed: {
    getCountSalariesUploaded() {
      return this.uploadedFiles.filter(uploaded => uploaded).length;
    },
    dynamicText() {
      var r1 = "";
      if (!window.matchMedia("screen and (max-width: 700px)").matches) {
        r1 = "Congratulations " + this.userName;
      } else {
        r1 = "Congratulations";
      }
      return r1;
    },
    dynamicTextName() {
      var r1 = "";
      if (!window.matchMedia("screen and (max-width: 700px)").matches) {
        r1 = "";
      } else {
        r1 = this.userName + "!";
      }
      return r1;
    }
  },

  methods: {
    ...conditions,
    salaryVerification: uploadService.salaryVerification,
    finishCallback() {
      GlobalVariables.isThankYouScreen = true;
      console.log(GlobalVariables);
      if (
        window.KAMPYLE_ONSITE_SDK &&
        typeof window.KAMPYLE_ONSITE_SDK.updatePageView() === "function"
      ) {
        window.KAMPYLE_ONSITE_SDK.updatePageView();
      }
      var decisionstatus = this.$store.state.transactionStatus;
      var employeeCodes = this.$store.state.employeeCodes;

      var subtitleMessage = "";
      var titleMessage = "";

      if (this.$store.state.employeeCodes) {
        titleMessage = `${this.getAppianStatus}!`;
        subtitleMessage = `Congratulations you qualify for a ${this.product}. Your application for a ${this.product} qualifies for up to AED ${this.getAppianPrescreened}. 
          Your customer identification number is ${this.getCifNumber}.`;
      } else {
        titleMessage = `Congratulations ${this.userName}!`;
        subtitleMessage = `You qualify for a Deem Credit Card. Our team will be in touch with you shortly.`;
      }
      this.showEndPage({
        title: titleMessage,
        subtitle: subtitleMessage
      });
    },
    increaseSalariesUploaded(index) {
      Vue.set(this.uploadedFiles, index, true);
    }
  }
};
</script>
<style scoped>
@media (max-width: 700px) {
  [class*="div.title"] {
    font-family: "Moderat", serif;
    font-weight: 10;
    font-size: 8px;
    line-height: 8px;
    letter-spacing: 0px;
    color: #000;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 20px;
  }
}
</style>
